(() => {
  const STYLE_ID = 'PowlifeSizeHelpFitStyles';
  const MODAL_ID = 'PowlifeSizeGuideModal';
  const WALK_SIZE_CHART_URL = 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_19_19.png?v=1788445246';

  const isHarnessLeashSet = () => {
    const path = location.pathname.toLowerCase();
    return path.includes('soft-no-pull-cat-harness-leash-set') || (path.includes('harness') && path.includes('leash') && path.includes('set'));
  };

  const isWalkExploreSet = () => location.pathname.toLowerCase().includes('/products/walk-explore-set');

  const isClassicSizeHelpProduct = () => {
    const path = location.pathname.toLowerCase();
    const isRetractableLeash = path.includes('retractable') && path.includes('leash');
    return isRetractableLeash || isHarnessLeashSet();
  };

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      [data-powlife-lower] .pll-help-panel--size-help.is-active{
        width:min(1380px,96vw)!important;
        margin:0 auto!important;
        display:grid!important;
        grid-template-columns:minmax(0,1fr)!important;
        min-height:0!important;
        border:0!important;
        background:transparent!important;
      }
      [data-powlife-lower] .pll-help-panel--size-help .pll-help-copy,
      [data-powlife-lower] .pll-help-panel--size-help .pll-arrow,
      [data-powlife-lower] .pll-help-panel--size-help .pll-copy{display:none!important}
      [data-powlife-lower] .pll-help-panel--size-help .pll-help-image--size-help{
        display:block!important;
        width:100%!important;
        min-height:0!important;
        height:auto!important;
        overflow:visible!important;
        background:transparent!important;
      }
      [data-powlife-lower] .pll-help-panel--size-help .pll-help-image--size-help img{
        display:block!important;
        width:100%!important;
        height:auto!important;
        max-height:none!important;
        aspect-ratio:auto!important;
        object-fit:contain!important;
        object-position:center top!important;
      }
      .pl-pdp .pl-option.has-mobile-size-guide legend,
      .pl-pdp .pl-option.has-walk-size-guide legend{
        position:relative!important;
        display:block!important;
        width:100%!important;
        padding-right:110px!important;
      }
      .pl-pdp .pl-option.has-mobile-size-guide .pl-size-guide-link,
      .pl-pdp .pl-option.has-walk-size-guide .pl-size-guide-link{
        display:inline-block!important;
        position:absolute!important;
        right:0!important;
        top:50%!important;
        transform:translateY(-50%)!important;
        border:0!important;
        background:transparent!important;
        padding:0!important;
        color:inherit!important;
        font:inherit!important;
        font-weight:800!important;
        letter-spacing:0!important;
        text-transform:none!important;
        text-decoration:underline!important;
        text-underline-offset:3px!important;
        cursor:pointer!important;
        white-space:nowrap!important;
      }
      .pl-size-guide-modal{
        position:fixed!important;
        inset:0!important;
        z-index:999999!important;
        display:flex!important;
        align-items:center!important;
        justify-content:center!important;
        padding:18px!important;
        background:rgba(0,0,0,.72)!important;
        opacity:0;
        visibility:hidden;
        pointer-events:none;
        transition:opacity .18s ease,visibility .18s ease;
      }
      .pl-size-guide-modal.is-open{
        opacity:1;
        visibility:visible;
        pointer-events:auto;
      }
      .pl-size-guide-modal__dialog{
        position:relative;
        width:min(96vw,1100px);
        max-height:92vh;
        overflow:auto;
        border-radius:12px;
        background:#fff;
        box-shadow:0 18px 50px rgba(0,0,0,.3);
      }
      .pl-size-guide-modal__image{
        display:block;
        width:100%;
        height:auto;
        object-fit:contain;
      }
      .pl-size-guide-modal__close{
        position:absolute;
        top:10px;
        right:10px;
        z-index:2;
        width:36px;
        height:36px;
        border:0;
        border-radius:50%;
        background:rgba(255,255,255,.94);
        color:#111;
        font-size:24px;
        line-height:1;
        font-weight:700;
        cursor:pointer;
        box-shadow:0 2px 12px rgba(0,0,0,.18);
      }
      body.pl-size-guide-modal-open{overflow:hidden!important}
      @media(max-width:749px){
        [data-powlife-lower] .pll-help-panel--size-help.is-active{width:calc(100% - 28px)!important}
        .pl-pdp .pl-option.has-mobile-size-guide legend,
        .pl-pdp .pl-option.has-walk-size-guide legend{
          padding-right:96px!important;
        }
        .pl-pdp .pl-option.has-mobile-size-guide .pl-size-guide-link{
          top:50%!important;
          transform:translateY(-50%)!important;
        }
        .pl-pdp .pl-option.has-walk-size-guide .pl-size-guide-link{
          top:7px!important;
          transform:none!important;
        }
        .pl-size-guide-modal{padding:10px!important}
        .pl-size-guide-modal__dialog{width:100%;max-height:94vh;border-radius:10px}
      }
    `;
    document.head.appendChild(style);
  };

  const restoreSingleImage = (panel) => {
    if (!panel) return;

    const firstImage = panel.querySelector('img');
    if (!firstImage) return;

    if (panel.dataset.careUseCarousel === 'true' || panel.classList.contains('pll-care-carousel-panel')) {
      const imageWrap = document.createElement('div');
      imageWrap.className = 'pll-help-image pll-help-image--size-help';
      const image = firstImage.cloneNode(true);
      image.removeAttribute('style');
      imageWrap.appendChild(image);
      panel.replaceChildren(imageWrap);
    }

    panel.removeAttribute('data-feature-carousel');
    panel.removeAttribute('data-care-use-carousel');
    delete panel.dataset.careUseCarousel;
    panel.classList.remove('pll-feature-panel', 'pll-care-carousel-panel', 'pl-story--published');
    panel.classList.add('pll-help-panel', 'pll-help-panel--size-help');

    const helpImage = panel.querySelector('.pll-help-image');
    if (helpImage) helpImage.classList.add('pll-help-image--size-help');
  };

  const closeSizeGuideModal = () => {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pl-size-guide-modal-open');
  };

  const openSizeGuideModal = (imageUrl = '') => {
    const sourceImage = imageUrl ? null : document.querySelector('[data-powlife-lower] [data-pll-panel="help"] img');
    if (!imageUrl && !sourceImage) return;

    let modal = document.getElementById(MODAL_ID);
    if (!modal) {
      modal = document.createElement('div');
      modal.id = MODAL_ID;
      modal.className = 'pl-size-guide-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Size guide');
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = `
        <div class="pl-size-guide-modal__dialog" role="document">
          <button type="button" class="pl-size-guide-modal__close" aria-label="Close size guide">×</button>
          <img class="pl-size-guide-modal__image" alt="Size guide">
        </div>
      `;
      document.body.appendChild(modal);

      modal.querySelector('.pl-size-guide-modal__close')?.addEventListener('click', closeSizeGuideModal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeSizeGuideModal();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) closeSizeGuideModal();
      });
    }

    const modalImage = modal.querySelector('.pl-size-guide-modal__image');
    if (!modalImage) return;

    if (imageUrl) {
      modalImage.src = imageUrl;
      modalImage.alt = 'Harness and leash size guide';
      modalImage.removeAttribute('srcset');
      modalImage.removeAttribute('sizes');
    } else {
      modalImage.src = sourceImage.currentSrc || sourceImage.src;
      modalImage.alt = sourceImage.alt || 'Size guide';
      if (sourceImage.srcset) modalImage.srcset = sourceImage.srcset;
      else modalImage.removeAttribute('srcset');
      if (sourceImage.sizes) modalImage.sizes = sourceImage.sizes;
      else modalImage.removeAttribute('sizes');
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pl-size-guide-modal-open');
  };

  const addSizeGuideButton = (fieldset, className, onClick) => {
    if (!fieldset) return;
    const legend = fieldset.querySelector('legend');
    if (!legend) return;

    fieldset.classList.add(className);
    if (legend.querySelector('.pl-size-guide-link')) return;

    const link = document.createElement('button');
    link.type = 'button';
    link.className = 'pl-size-guide-link';
    link.textContent = 'Size Guide';
    link.setAttribute('aria-label', 'View size guide');
    link.addEventListener('click', onClick);
    legend.appendChild(link);
  };

  const ensureHarnessSizeGuide = () => {
    if (!isHarnessLeashSet()) return;

    const fieldsets = [...document.querySelectorAll('.pl-pdp .pl-option')];
    const sizeFieldset = fieldsets.find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      const buttons = [...fieldset.querySelectorAll('.pl-option__button')];
      const values = buttons.map((button) => (button.dataset.optionValue || button.textContent || '').trim().toUpperCase());
      return legend && legend.textContent.trim().toUpperCase().startsWith('SIZE:') && values.some((value) => value.startsWith('S (3')) && values.some((value) => value.startsWith('XXL (23'));
    });

    addSizeGuideButton(sizeFieldset, 'has-mobile-size-guide', () => openSizeGuideModal());
  };

  const ensureWalkExploreSizeGuide = () => {
    if (!isWalkExploreSet()) return;

    const fieldsets = [...document.querySelectorAll('.pl-pdp .pl-option')];
    const sizeFieldset = fieldsets.find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      const legendText = (legend?.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      const values = [...fieldset.querySelectorAll('.pl-option__button')].map((button) =>
        (button.dataset.optionValue || button.getAttribute('title') || button.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase()
      );
      const hasSmall = values.some((value) => /(?:^|\/)\s*S\s*\(3[–-]6\s*LB\)/i.test(value));
      const hasXXL = values.some((value) => /(?:^|\/)\s*XXL\s*\(23[–-]30\s*LB\)/i.test(value));
      return legend && legendText.includes('COMPATIBILITY') && legendText.includes('SIZE') && hasSmall && hasXXL;
    });

    addSizeGuideButton(sizeFieldset, 'has-walk-size-guide', () => openSizeGuideModal(WALK_SIZE_CHART_URL));
  };

  const apply = (root = document) => {
    if (!isClassicSizeHelpProduct() && !isWalkExploreSet()) return;

    ensureStyles();

    if (isClassicSizeHelpProduct()) {
      root.querySelectorAll?.('[data-powlife-lower]').forEach((section) => {
        const tabs = section.querySelectorAll('[data-pll-tab]');
        if (tabs[1]) tabs[1].textContent = 'Size Help';
        restoreSingleImage(section.querySelector('[data-pll-panel="help"]'));
      });
      ensureHarnessSizeGuide();
    }

    ensureWalkExploreSizeGuide();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
  } else {
    apply();
  }

  document.addEventListener('powlife:care-carousel-data', () => apply(document));
  document.addEventListener('shopify:section:load', (event) => apply(event.target));
})();
